// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetClaimAndProductDetails = () =>

    dispatch => {

        dispatch({
            type: actions.RESET_CLAIM_PIP_PIP_PRODUCTS
        });

        dispatch({
            partNumber: '',
            type: actions.UPDATE_CLAIM_PIP_FAILURE_PART
        });

        dispatch({
            type: actions.RESET_CLAIM_PIP_PIP_DETAILS
        });

        dispatch({
            type: actions.RESET_CLAIM_PIP_PRODUCT_DETAILS
        });

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/reset-claim-and-product-details.js